import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ziyuan",
  "use": "icon-ziyuan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ziyuan\"><path d=\"M0 398.222L455.111 0v232.96C1024 369.778 1024 1024 1024 1024S824.889 564.053 455.111 564.053v232.391z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol